import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import FormInput from '../../common/components/FormInput'; 
import UserFormInput from './UserFormInput';
import UserPermissionTable from './UserPermissionTable';
import ChangePasswordModal from './ChangePasswordModal';

const EditUserForm = ({
  handleSubmit,
  onCancel,
  onTogglePermission,
  permissionTable,
  status,
  submitting,
  username,
  modalOpen,
  onPasswordAccept,
  onCloseModal,
  onOpenModal,
  newPassword,
  confirmPassword,
  passwordError,
  onPasswordChange,
  onConfirmPasswordChange,
  supportsCareSheet
}) => {
  return (
    <div className="container-fluid main" id="main">
      <div className="row">
        <div className="col-lg-12">
          <h1>{I18n.t('EDIT_USER')}</h1>
          <form className="user-form" onSubmit={handleSubmit}>
            <div className="row no-gutters">
              <div className="col-sm-12">
                <h5>{I18n.t('USER_INFO')}</h5>
              </div>
            </div>
            <div className="row">
              <label className="col-lg-2 col-sm-3 col-form-label">{I18n.t('EMAIL_ADDRESS')}</label>
              <div className="col-lg-10 col-sm-9">
                <span className="email">{username}</span>
              </div>
            </div>
            <Field name="firstName"
                   component={UserFormInput}
                   type="text"
                   label={I18n.t('FIRST_NAME')}
            />
            <Field name="lastName"
                   component={UserFormInput}
                   type="text"
                   label={I18n.t('LAST_NAME')}
            />
            <div className="row">
              <label htmlFor="change-password" className="col-lg-2 col-sm-3 col-form-label">{I18n.t('PASSWORD')}</label>
              <div className="col-lg-10 col-sm-9">
                <button type="button" 
                        name="change-password" 
                        className="change-password btn btn-link" 
                        onClick={onOpenModal}>{I18n.t('CHANGE_PASSWORD')}</button>
              </div>
            </div>
            <div className="row">
              <label htmlFor="status" className="col-lg-2 col-sm-3 col-form-label">{I18n.t('STATUS')}</label>
              <div className="col-lg-10 col-sm-9">
                <label className="switch">
                    <Field name="status"
                           component={FormInput}
                           type="checkbox"
                    />
                    <div className="slider"/>
                </label>
                <label className="lbl-active">{status ? I18n.t('ACTIVE') : I18n.t('INACTIVE')}</label>
              </div>
            </div> 
            <UserPermissionTable permissionTable={permissionTable} onTogglePermission={onTogglePermission} supportsCareSheet = {supportsCareSheet}/>
            <div className="row no-gutters bottom-buttons">
              <div className="col-sm-12 text-right">
                <button type="button" className="btn btn-secondary" disabled={submitting} onClick={onCancel}>{I18n.t('CANCEL')}</button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>{I18n.t('SAVE')}</button> 
              </div>
            </div>
          </form> 
        </div>
      </div>
      <ChangePasswordModal isOpen={modalOpen} 
                            onAccept={onPasswordAccept} 
                            onClose={onCloseModal} 
                            newPassword={newPassword} 
                            confirmPassword={confirmPassword}
                            passwordError={passwordError}
                            onPasswordChange={onPasswordChange}
                            onConfirmPasswordChange={onConfirmPasswordChange} />
    </div>
  );
};

EditUserForm.propTypes = {
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onTogglePermission: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  permissionTable: PropTypes.array.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  status: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  subscriptions: PropTypes.array,
  username: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  onPasswordAccept: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  newPassword: PropTypes.string.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  passwordError: PropTypes.string.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onConfirmPasswordChange: PropTypes.func.isRequired,
  supportsCareSheet : PropTypes.bool.isRequired,
};

EditUserForm.defaultProps = {
  username: ''
};

export default reduxForm()(EditUserForm);


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/EditUserForm.js
 **/